var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05728 2.44801C0.894969 2.2857 0.894969 2.02254 1.05728 1.86023L1.81515 1.10236C1.97747 0.940045 2.24063 0.940045 2.40294 1.10236L13.2769 11.9764C13.4393 12.1387 13.4393 12.4018 13.2769 12.5642L12.5191 13.322C12.3568 13.4843 12.0936 13.4843 11.9313 13.322L1.05728 2.44801Z",
    fill: "url(#paint0_linear_420_133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9324 0.916656C12.0947 0.754344 12.3579 0.754344 12.5202 0.916656L13.278 1.67453C13.4404 1.83684 13.4404 2.1 13.278 2.26231L2.40403 13.1363C2.24172 13.2986 1.97856 13.2986 1.81625 13.1363L1.05837 12.3784C0.896061 12.2161 0.896061 11.953 1.05837 11.7907L11.9324 0.916656Z",
    fill: "url(#paint1_linear_420_133)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_420_133",
    x1: 0.935547,
    y1: 7.11934,
    x2: 13.3998,
    y2: 7.11934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE8500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_420_133",
    x1: 0.935547,
    y1: 7.11934,
    x2: 13.3998,
    y2: 7.11934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE8500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoClose);
export default __webpack_public_path__ + "static/media/info_close.0d60593afc4a7321446b9d83378b5137.svg";
export { ForwardRef as ReactComponent };